import {
  AYS_CODING_SYSTEM_CLASSIFICATIONS,
  type AysCodingSystemClassification,
} from './code-classification';
import type { AysCodeCodingSystem } from './code-type.model';

/**
 * The hierarchy level a coding system starts on. Kept as its own constant so a
 * host that hides the inline coding-system select can reset the level exactly as
 * this control would have.
 */
export const CODE_TYPE_CLASSIFICATION_DEFAULTS: {
  [codingSystem in AysCodeCodingSystem]?: AysCodingSystemClassification;
} = {
  'ICD-10-GM': AYS_CODING_SYSTEM_CLASSIFICATIONS['ICD-10-GM'][0], // 3 numbers of digits
  OPS: AYS_CODING_SYSTEM_CLASSIFICATIONS.OPS[2], // 4 numbers of digits
  'G-DRG': null,
};

/**
 * The hierarchy level to select when a coding system is chosen: its documented
 * default, or its coarsest level for a system without one. Undefined for a
 * system that has no levels at all (G-DRG), which is the value its consumers
 * already treat as "no level".
 */
export function codeTypeClassificationDefault(
  codingSystem: AysCodeCodingSystem,
): AysCodingSystemClassification | undefined {
  return (
    CODE_TYPE_CLASSIFICATION_DEFAULTS[codingSystem] ??
    AYS_CODING_SYSTEM_CLASSIFICATIONS[codingSystem]?.[0]
  );
}
